import {TriggerQuery} from '@models/adminstration/machine/trigger/trigger-query/trigger-query';
import {TRIGGER_ACTION_TYPE} from '@constants/trigger/trigger-action-type.constant';
import {MessageContentType} from '@models/adminstration/machine/trigger/trigger-query/message-content-type';
import {
  AdditionalMessageField,
  AdditionalMessageFieldTypes
} from '@models/adminstration/machine/trigger/trigger-query/additional-message-field/additional-message-field';
import {TRIGGER_SIGNAL_TYPE} from '@constants/administration/machine/trigger-signal-label';

export class AddTriggerQueryRequest {
  delayInSeconds?: string;
  email?: string | null;
  id: number;
  initQueryExecuted: boolean;
  message?: string;
  name: string;
  subject?: string;
  triggerActionType: string;
  topic?: string | null;
  notificationSubscriptions?: string[] | null;
  messageContentType: MessageContentType = MessageContentType.TEXT;
  additionalMessageFields: AdditionalMessageField[];

  constructor(triggerQuery: TriggerQuery) {
    this.messageContentType = triggerQuery.messageContentType;
    this.additionalMessageFields = triggerQuery.additionalMessageFields || [];
    this.delayInSeconds = triggerQuery.delayInSeconds;
    this.email = triggerQuery.email;
    this.id = triggerQuery.id;
    this.initQueryExecuted = triggerQuery.initQueryExecuted;
    this.message = triggerQuery.message;
    this.name = triggerQuery.name;
    this.subject = triggerQuery.subject;
    this.triggerActionType = triggerQuery.triggerActionType;
    this.topic = triggerQuery.topic;
    this.notificationSubscriptions = triggerQuery.notificationSubscriptions;

    if (triggerQuery.triggerActionType === TRIGGER_ACTION_TYPE.PUBSUB) {
      delete this.email;
      delete this.subject;
      this.additionalMessageFields = this.additionalMessageFields.map(({value, fieldName}) => {
        return {
          value: fieldName === AdditionalMessageFieldTypes.EventSeverity ? this.parseSeverityValue(value as TRIGGER_SIGNAL_TYPE) : value,
          fieldName,
        } as AdditionalMessageField;
      });
    } else if (triggerQuery.triggerActionType === TRIGGER_ACTION_TYPE.NOTIFICATION) {
      delete this.email;
      delete this.topic;
    } else {
      delete this.topic;
    }
  }

  private parseSeverityValue(event: TRIGGER_SIGNAL_TYPE): number {
    switch (event) {
      case TRIGGER_SIGNAL_TYPE.ERROR:
        return 0;
      case TRIGGER_SIGNAL_TYPE.WARNING:
        return 1;
      case TRIGGER_SIGNAL_TYPE.INHIBIT:
        return 2;
      case TRIGGER_SIGNAL_TYPE.INFO:
        return 3;
      case TRIGGER_SIGNAL_TYPE.DEBUG:
        return 4;
    }
  }
}
